import { render, staticRenderFns } from "./Hxpxsgmtj.vue?vue&type=template&id=cd7fb676&scoped=true&"
import script from "./Hxpxsgmtj.vue?vue&type=script&lang=js&"
export * from "./Hxpxsgmtj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd7fb676",
  null
  
)

export default component.exports